import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { LangProvider } from "@/context/LangContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Portal from "@/pages/Portal";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import LeadDetail from "@/pages/LeadDetail";
import LegalPage from "@/pages/LegalPage";
import AuthCallback from "@/pages/AuthCallback";
import CaseWorkspace from "@/pages/CaseWorkspace";

function AppRoutes() {
  const location = useLocation();
  // Detetar o retorno do OAuth Google (session_id no fragmento) antes de qualquer rota protegida.
  if (location.hash && location.hash.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Portal />} />
      <Route path="/privacidade" element={<LegalPage docKey="privacidade" />} />
      <Route path="/termos" element={<LegalPage docKey="termos" />} />
      <Route path="/disclaimer" element={<LegalPage docKey="disclaimer" />} />
      <Route path="/entrar" element={<Login />} />
      <Route path="/painel" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/painel/lead/:id" element={<ProtectedRoute><LeadDetail /></ProtectedRoute>} />
      <Route path="/painel/casos/prototipo" element={<ProtectedRoute><CaseWorkspace /></ProtectedRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <LangProvider>
        <AuthProvider>
          <BrowserRouter>
            <AppRoutes />
            <Toaster theme="light" position="top-right" richColors />
          </BrowserRouter>
        </AuthProvider>
      </LangProvider>
    </div>
  );
}

export default App;
